import React, { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { getBuildings, registerVisitor } from '../api/api';
import { ToastContainer } from 'react-toastify';
import RegistrationSuccess from '../components/RegistrationSuccess';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

const validationSchema = Yup.object({
    buildingId: Yup.string().required('Building is required'),
    // email: Yup.string().email('Invalid email').required('Email is required'),
    unitNumber: Yup.string().required('Unit Number is required'),
    plateNumber: Yup.string()
        .matches(/^[A-Za-z0-9]+$/, 'Plate number must be alphanumeric only')
        .required('License Plate Number is required'),
    nights: Yup.number()
        .typeError('Must be a number')
        .min(1, 'At least 1 night')
        .required('Number of Nights is required'),
    startTime: Yup.string().required('Start Time is required'),
});

const VisitorParkingForm = () => {
    const inputRef = useRef();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [buildingOptions, setBuildingOptions] = useState([]);
    const [isRegistered, setIsRegistered] = useState(false);
    const [registeredData, setRegisteredData] = useState(null);
    const formik = useFormik({
        initialValues: {
            buildingId: '',
            // email: '',
            unitNumber: '',
            plateNumber: '',
            nights: '',
            startTime: '',
        },
        validationSchema,
        onSubmit: async (values) => {
            try {
                console.log('Form submitted:', values);
                setLoading(true);
                // Add API call here
                const res = await registerVisitor(values);
                setIsRegistered(true);
                setLoading(false);
                setRegisteredData(res.data);
                // Reset form
                formik.resetForm();
            } catch (error) {
                setLoading(false);
            }
        },
    });

    const getMaxNights = (buildingId) => {
        const building = buildingOptions.find((b) => b._id === buildingId);
        return building ? getCount(building) : 0;
    };

    const getCount = (data) => {
        if (data.maxNightPerWeek > 0) {
            return data.maxNightPerWeek;
        } else if (data.maxNightPerMonth > 0) {
            return data.maxNightPerMonth;
        } else if (data.maxNightPerYear > 0) {
            return data.maxNightPerYear;
        }
        return data.nights;
    }


    useEffect(() => {
        // Fetch buildingId options from your API
        const fetchBhildings = async () => {
            const res = await getBuildings();
            setBuildingOptions(res);
        };
        fetchBhildings();
    }, []);

    return (
        <div className="min-h-screen flex flex-col md:flex-row">
            {/* Left: Form */}
            <div className="md:w-1/2 w-full bg-[#212121] text-white py-[25px] px-[25px] sm:px-[50px] lg:px-[91px] lg:py[66px] flex flex-col justify-center">

                <div className="mb-6 text-center">
                    <img src='./logo-transparent-png.png' alt="Logo" className="mx-auto w-[70%]" />
                </div>

                {!isRegistered ? <form onSubmit={formik.handleSubmit} className="space-y-4">
                    {/* Building */}
                    <div>
                        <label className="text-sm block mb-1 text-left">Site ID/Building Street Name</label>
                        <select
                            name="buildingId"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.buildingId}
                            className="w-full px-3 py-2 bg-black border border-gray-700 rounded text-white"
                        >
                            <option value="">Select Building</option>
                            {buildingOptions.map((building) => (
                                <option key={building._id} value={building._id}>
                                    {building.name}
                                </option>
                            ))}

                        </select>
                        {formik.touched.buildingId && formik.errors.buildingId && (
                            <p className="text-red-400 text-sm mt-1 text-left">{formik.errors.buildingId}</p>
                        )}
                    </div>

                    {/* Email */}
                    {/* <div>
                        <label className="text-sm block mb-1 text-left">Email</label>
                        <input
                            type="email"
                            name="email"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.email}
                            className="w-full px-3 py-2 bg-black border border-gray-700 rounded text-white"
                            placeholder="Enter email"
                        />
                        {formik.touched.email && formik.errors.email && (
                            <p className="text-red-400 text-sm mt-1 text-left">{formik.errors.email}</p>
                        )}
                    </div> */}

                    {/* Unit */}
                    <div>
                        <label className="text-sm block mb-1 text-left">Unit Number</label>
                        <input
                            type="text"
                            name="unitNumber"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.unitNumber}
                            className="w-full px-3 py-2 bg-black border border-gray-700 rounded text-white"
                            placeholder="Unit Number"
                        />
                        {formik.touched.unitNumber && formik.errors.unitNumber && (
                            <p className="text-red-400 text-sm mt-1 text-left">{formik.errors.unitNumber}</p>
                        )}
                    </div>

                    {/* License Plate */}
                    <div>
                        <label className="text-sm block mb-1 text-left">License Plate Number</label>
                        <input
                            type="text"
                            name="plateNumber"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.plateNumber}
                            className="w-full px-3 py-2 bg-black border border-gray-700 rounded text-white"
                            placeholder="Plate Number"
                        />
                        {formik.touched.plateNumber && formik.errors.plateNumber && (
                            <p className="text-red-400 text-sm mt-1 text-left">{formik.errors.plateNumber}</p>
                        )}
                    </div>

                    {/* Nights */}
                    <div>
                        <label className="text-sm block mb-1 text-left">Number of Nights</label>
                        <input
                            type="number"
                            name="nights"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.nights}
                            max={getMaxNights(formik.values.buildingId)}
                            min={1}
                            className="w-full px-3 py-2 bg-black border border-gray-700 rounded text-white"
                            placeholder="e.g., 2"
                        />
                        {formik.touched.nights && formik.errors.nights && (
                            <p className="text-red-400 text-sm mt-1 text-left">{formik.errors.nights}</p>
                        )}
                    </div>

                    {/* Start Time */}
                    <div>
                        <label className="text-sm block mb-1 text-left">Start Time</label>
                        <input
                            ref={inputRef}
                            type="datetime-local"
                            name="startTime"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.startTime}
                            className="w-full px-3 py-2 bg-black border border-gray-700 rounded text-white"
                            onClick={() => inputRef.current?.showPicker()}
                            min={moment().format("YYYY-MM-DDTHH:mm")}   // 👈 prevents past dates
                        />
                        {formik.touched.startTime && formik.errors.startTime && (
                            <p className="text-red-400 text-sm mt-1 text-left">{formik.errors.startTime}</p>
                        )}
                    </div>

                    <button
                        type="submit"
                        className="w-full bg-teal-500 hover:bg-teal-600 text-white py-2 rounded mt-4"
                        disabled={loading}
                    >
                        REGISTER
                    </button>
                    {/* Footer */}
                    <div className="mt-6 text-sm text-center text-gray-400 space-y-1 flex justify-end items-baseline">
                        {/* <p>613-720-5021</p>
                        <p>|</p>
                        <p>
                            Have a question?{' '}
                        </p>
                        <p>|</p> */}
                        <p><span className="text-teal-400 underline cursor-pointer hover:text-teal-500" onClick={() => navigate('/member-login')}>
                            Member login
                        </span></p>
                    </div>
                </form> :
                    <RegistrationSuccess registeredData={registeredData} setIsRegistered={setIsRegistered} />
                }

            </div>

            {/* Right: Image */}
            <div className="md:w-1/2 w-full bg-gray-100 flex justify-center">
                <img
                    src="/parking-image.png"
                    alt="Parking"
                    className="w-full h-full object-cover hidden md:block"
                />
            </div>
            <ToastContainer
                closeButton={false}
                autoClose={5000}
                position='top-right'
            />
        </div>
    );
};

export default VisitorParkingForm;
